import SetupBaseController from '../common/setup.base.controller'

class setupallController extends SetupBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, SetupService, $translate, $stateParams,$location) {
    super(Auth, $state, User, SetupService, Modal, $translate, $stateParams, $location)

    this.loading = true
    this.setups = []
    this.hasAcl = {}
    this.page = 1;
    this.total = 0;
    this.pageLimit = 10;
    this.maxPages = 10
    this.searchText = '';
    this.$location = $location
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(setup) {
    this.$state.go('setup.edit', ({
      id: setup.id
    }))
  }

  delete(setup) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ' ' + this.$translate.instant('setup.setupFor') + ` <strong>${setup.branchId}</strong>?`,
      callback: ({
        modal,
        $scope
      }) => {
        $scope.loading = true;
        this.Service.remove(setup.id, setup.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close();
            this.refresh();
          })
      },
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    return {
      queryText: '%' + this.searchText + '%',
      isQuery: false
    }
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();

    this.loading = true
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.setups = data.results
      })
      .catch((err) => {
        this.error = err.message
      })
      .finally(() => {
        this.loading = false
      });
  }
}

export default setupallController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/all/setup.all.controller.js